module.exports = __webpack_public_path__ + "img/bg_bottom_left_corner.d14f4418.png";